<template>
  <v-container small>
    <v-row align="center" justify="center">
      <v-col cols="12" md="8">
        <v-card elevation="0">
          <v-card-title class="font-weight-light text-h4">{{ $route.meta.tip }} Retrieval</v-card-title>
          <v-stepper vertical v-model="passwordStep" class="elevation-0">
            <v-stepper-step :complete="passwordStep > 1" step="1">Identify Yourself</v-stepper-step>
            <v-stepper-content step="1">
              <v-form ref="indentifyForm" v-model="identityValid">
                <v-card tile elevation="0" :loading="loadingAcct">
                  <v-card-text class="pb-0">
                    <p class="text-h6">Please enter your User Name</p>
                    <v-btn to="/username" class="text-capitalize p-0" link text color="primary">I don't know my User Name</v-btn>
                    <div class="mt-10">
                      <v-text-field
                        type="text"
                        name="username"
                        autocapitalize="off"
                        :disabled="loadingAcct"
                        @blur="resetBlurValid"
                        prepend-inner-icon="mdi-account-search"
                        @keydown.enter.prevent="findAccount"
                        :rules="userRules"
                        label="User Name *"
                        outlined
                        v-model="userName"
                        required
                      ></v-text-field>
                    </div>
                  </v-card-text>
                  <v-card-actions class="pt-1">
                    <v-row dense>
                      <v-col cols="12">
                        <template>
                          <vue-recaptcha
                            @verify="captAction(true)"
                            @expired="captAction(false)"
                            sitekey="6Le37CUTAAAAAIjclCmXF2YLjBSpk0d3wiO9Qp7y"
                            :loadRecaptchaScript="true"
                          ></vue-recaptcha>
                        </template>
                      </v-col>
                      <v-col cols="12">
                        <v-btn
                          :loading="loadingAcct"
                          @click="findAccount"
                          :disabled="!identityValid || !captOk"
                          color="primary"
                          depressed
                          min-width="125px"
                          width="50%"
                        >
                          Find account
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-stepper-content>
            <v-stepper-step step="2" :complete="passwordStep > 2">Email Check</v-stepper-step>
            <v-stepper-content step="2">
              <v-slide-y-transition mode="out-in">
                <template v-if="loadingEmails">
                  <v-progress-circular color="deep-purple accent-4" indeterminate></v-progress-circular>
                </template>
                <template v-if="!loadingEmails && emailList.length > 1">
                  <div>
                    <label class="font-weight-bold">Where should send your Password?</label>

                    <v-radio-group v-model="chosenEmail" class="px-3">
                      <v-radio v-for="item in emailList" :key="item.email_type" :label="item.semail" :value="item.semail"></v-radio>
                    </v-radio-group>
                  </div>
                </template>
              </v-slide-y-transition>
              <v-slide-y-transition>
                <v-card-actions v-if="emailList.length > 1 && !loadingEmails">
                  <v-btn outlined color="primary" @click="passwordStep = 1" :disabled="loadingAcct">Back</v-btn>
                  <v-btn
                    :disabled="chosenEmail == ''"
                    :loading="loadingAcct"
                    depressed
                    color="primary"
                    @click="SendUserPassword(chosenEmail, userName)"
                  >
                    Next
                  </v-btn>
                </v-card-actions>
              </v-slide-y-transition>
            </v-stepper-content>
            <v-stepper-step step="3" :complete="passwordStep > 3">Confirm</v-stepper-step>
            <template v-if="emailList != ''">
              <v-stepper-content step="3">
                <p v-if="emailList.length > 0">
                  Your Password has been reset and sent to
                  <b>{{ chosenEmail }}</b>
                  . Please remember to check your "spam" or "junk" folder for this email. If you don't receive this email within 15 minutes,
                  <!-- {{ emailList[0].service_msg }} ACCTMG-4966-->
                  <span v-html="emailList[0].service_msg"></span>
                  <a :href="'tel:' + emailList[0].service_phone">{{ emailList[0].service_phone }}</a>
                  {{ emailList[0].service_hours }}.
                </p>

                <p v-else>
                  Your Password has been reset and sent to
                  <b>{{ chosenEmail }}</b>
                  . Please remember to check your "spam" or "junk" folder for this email. If you don't receive this email within 15 minutes, you may
                  call our Client Services department at
                  <a :href="'tel:' + emailList[0].service_phone">{{ emailList[0].service_phone }}</a>
                  {{ emailList[0].service_hours }}.
                </p>

                <!-- you may call our Client Services department at -->
                <v-card-actions>
                  <v-btn outlined color="primary" :href="getHome">Back to Login</v-btn>
                  <v-btn depressed color="primary" :to="'/' + queryStr">Start Over</v-btn>
                </v-card-actions>
              </v-stepper-content>
            </template>
          </v-stepper>
        </v-card>
        <v-dialog v-model="notFound" persistent max-width="350">
          <v-card>
            <v-card-title class="headline pink--text accent-4">Username not found</v-card-title>
            <v-card-text>
              We were unable to find any Username matching
              <b>{{ userName }}</b>
              . Would you like to try again or find your Username first?
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text :to="'/username' + queryStr">Get Username</v-btn>
              <v-btn color="primary" text @click="notFound = false">Try Again</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </v-container>
</template>
<style scoped>
.g-recaptcha {
  transform: scale(0.77);
  transform-origin: 0 0;
}
</style>
<script>
import axios from "axios";
import { mapGetters } from "vuex";
import VueRecaptcha from "vue-recaptcha";
export default {
  name: "password",
  components: { VueRecaptcha },
  data: function () {
    return {
      captOk: false,
      passwordStep: 1,
      selectedEmail: null,
      chosenEmail: "",
      identityValid: true,
      loadingEmails: false,
      notFound: false,
      userName: "",
      emailList: [
        {
          record_id: 1,
          email_address: "nhugh406@gmail.com",
        },
        { record_id: 2, email_address: "nhughes@basusa.com" },
      ],
      loadingAcct: false,
      userRules: [(v) => !!v || "User Name is required"],
    };
  },
  props: ["retrievalSelection"],
  watch: {
    userName: function () {
      if (this.userName == "") {
        this.resetValidation();
      }
    },
    passwordStep: function () {
      var self = this;
      if (self.passwordStep == 2) {
        self.loadingEmails = true;
        setTimeout(function () {
          self.loadingEmails = false;
          if (self.emailList.length < 2) {
            self.passwordStep = 3;
          }
        }, 2000);
      }
    },
  },
  computed: {
    ...mapGetters(["getHome"]),
    queryStr() {
      return this.$store.getters.getParams;
    },
  },
  methods: {
    captAction(r) {
      var self = this;
      self.captOk = r;
    },
    handleRetrieveError(r) {
      this.$emit("retrieve-error", r);
      this.loadingEmails = false;
      this.loadingAcct = false;
    },
    locateUsername() {
      this.$emit("change-window", 2);
    },
    resetForm() {
      this.$emit("reset-form");
      this.userName = "";
      this.passwordStep = 1;
    },
    findAccount() {
      var self = this;
      if (self.identityValid) {
        this.loadingAcct = true;
        self.loadingEmails = true;
        axios
          .post("/web_projects/UsernamePassword/WebMethods.aspx/GetUserEmail", {
            user_name: self.userName,
          })
          .then(function (response) {
            if (response.data.d == 0) {
              self.loadingAcct = false;
              self.notFound = true;
            } else {
              self.emailList = JSON.parse(response.data.d);
              if (self.emailList.length > 1) {
                self.loadingEmails = false;
                self.passwordStep = 2;
                self.loadingAcct = false;
              } else {
                self.SendUserPassword(self.emailList[0].semail, self.userName);
              }
            }
          })
          .catch(function () {
            self.notFound = true;
            self.loadingEmails = false;
            self.loadingAcct = false;
          });
      }
    },
    SendUserPassword(r, s) {
      var self = this;
      self.chosenEmail = r;
      self.loadingAcct = true;
      axios
        .post("/web_projects/UsernamePassword/WebMethods.aspx/SendUserPassword", {
          user_email: r,
          user_name: s,
        })
        .then(function () {
          self.passwordStep = 3;
          self.loadingAcct = false;
        })
        .catch(function (error) {
          if (error.response) {
            alert("there was an error sending the email.");
          }
        });
    },
    validate() {
      this.$refs.indentifyForm.validate();
    },
    resetValidation() {
      this.$refs.indentifyForm.resetValidation();
    },
    resetBlurValid() {
      if (this.userName == "") {
        this.$refs.indentifyForm.resetValidation();
      }
    },
  },
};
</script>
